import { EMAIL_REGEXP } from '@pbk/utils';
import { z } from 'zod';

// Birth number has to be divisible by 11 without remainder
export const BIRTH_NUMBER_DIVISOR = 11;

export const PID_UUID_LENGTH = 36;

export const IDENTITY_CARD_NUMBER_LENGTH = 9;
export const IDENTITY_CARD_NUMBER_REGEX = /^[0-9]*$/;

export const FIRST_NAME_OR_LAST_NAME_MAX_LENGTH = 40;
export const FIRST_NAME_OR_LAST_NAME_REGEX = /^([aA-žŽ]|\s|-)*$/;

export const BIRTH_NUMBER_MIN_LENGTH = 9;
export const BIRTH_NUMBER_MAX_LENGTH = 10;
export const BIRTH_NUMBER_REGEX = /^[0-9]*$/;

export const INSURANCE_NUMBER_MAX_LENGTH = 12;
export const INSURANCE_NUMBER_REGEX = /^[0-9a-zA-Z]*$/;

export const UNSPECIFIED_NUMBER_MAX_LENGTH = 20;
export const UNSPECIFIED_NUMBER_REGEX = /^[0-9a-zA-Z]*$/;

export const LEADING_ZEROS_REGEX = /^0+/;

export const UUID_SCHEMA_WITHOUT_NULL = z.union([z.literal(''), z.uuid()]);

export const UUID_SCHEMA = UUID_SCHEMA_WITHOUT_NULL.nullable();

export const EMAIL_SCHEMA = z.email({ pattern: EMAIL_REGEXP });

export const EMAIL_OR_EMPTY_SCHEMA = EMAIL_SCHEMA.or(z.literal(''));

export const ONLY_DIGITS_REGEX = /^[0-9]+$/;

// Set the minimum birthday date to 1900-01-01, more - https://projektpb.atlassian.net/browse/KLS-2872
export const MIN_BIRTHDAY_DATE: Date = new Date(1900, 0, 1);

// Set the maximum birthday date to the current date, more - https://projektpb.atlassian.net/browse/KLS-2872
export const MAX_BIRTHDAY_DATE: Date = new Date();
export const DAY_MIN = 1;
export const DAY_MAX = 31;

export const CONTROL_DIGIT_SPECIAL_CASE = 10;

export const RAW_YEAR_LIMIT = 54;
export const YEAR_OFFSET_WITH_CONTROL_LOWER = 2000;
export const YEAR_OFFSET_WITH_CONTROL_UPPER = 1900;
export const YEAR_OFFSET_WITHOUT_CONTROL_LOWER = 1900;
export const YEAR_OFFSET_WITHOUT_CONTROL_UPPER = 1800;

export const YEAR_SLICE_START = 0;
export const YEAR_SLICE_END = 2;
export const MONTH_SLICE_START = 2;
export const MONTH_SLICE_END = 4;
export const DAY_SLICE_START = 4;
export const DAY_SLICE_END = 6;

export const CONTROL_DIGIT_INDEX = 9;
export const NUMBER_WITHOUT_CONTROL_END = 9;

export const MONTH_OFFSET_70 = 70;
export const MONTH_OFFSET_50 = 50;
export const MONTH_OFFSET_20 = 20;
export const YEAR_THRESHOLD = 2003;

export const MIN_VALID_YEAR = 1900;
export const USER_ID_MIN_LENGTH = 3;
export const USER_ID_MAX_LENGTH = 6;

export const USER_DOCUMENT_NUMBER_MIN_LENGTH = 6;
export const USER_DOCUMENT_NUMBER_MAX_LENGTH = 20;
